/**
 * sanitizePlain — Sanitização defensiva de strings de texto puro vindas do
 * backend (descrição da cobrança, itens, etc.) para exibição na página
 * pública /c/:slug.
 *
 * Não usamos `dangerouslySetInnerHTML` aqui: React já escapa HTML, mas
 * removemos NULs, sequências de controle e tags HTML cruas como camada
 * extra de defesa contra payloads adulterados.
 *
 * RELEASE: 2026-06-21 v1.0.0 — Versão inicial.
 */

const MAX_LEN = 5000;

export function sanitizePlain(input: string | null | undefined): string {
  if (!input) return '';
  let s = String(input);
  // Remove caracteres de controle (exceto \n, \r e \t)
  // eslint-disable-next-line no-control-regex
  s = s.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '');
  // Remove tags HTML cruas (defensivo — React já escaparia, mas evita pollution visual)
  s = s.replace(/<\/?[^>]+>/g, '');
  // Limita tamanho
  if (s.length > MAX_LEN) s = s.slice(0, MAX_LEN) + '…';
  return s.trim();
}
